import React from 'react';

import AuthLayout from 'components/authentication/AuthLayout';
import PasswordRecoveryForm from 'components/authentication/PasswordRecoveryForm';


const PasswordRecoveryPage = () => (
  <AuthLayout className="password-recovery-page__component">
    <PasswordRecoveryForm />
  </AuthLayout>
);

export default PasswordRecoveryPage;
